import { authFetch } from 'auth/utils';
import { envVariables } from 'common/utils/envVariables';
import { SimProductAction } from 'products/sim/Actions/constants/simProductActions';

export const activateCards = async (props: { iccids: string[] }) => {
  const availableActionsResponse = await authFetch(
    `${envVariables.VITE_SIM_PRODUCTS_API}/in-life-changes/activation`,
    {
      method: 'POST',
      body: JSON.stringify(props),
      headers: {
        'Content-Type': 'application/json',
      },
    },
  );

  if (!availableActionsResponse.ok) {
    throw new Error('Something went wrong'); //Be improed in next MR
  }
};

export const suspendCards = async (props: { iccids: string[] }) => {
  const availableActionsResponse = await authFetch(
    `${envVariables.VITE_SIM_PRODUCTS_API}/in-life-changes/suspension`,
    {
      method: 'POST',
      body: JSON.stringify(props),
      headers: {
        'Content-Type': 'application/json',
      },
    },
  );

  if (!availableActionsResponse.ok) {
    throw new Error('Something went wrong'); //Be improed in next MR
  }
};

export const unsuspendCards = async (props: { iccids: string[] }) => {
  const availableActionsResponse = await authFetch(
    `${envVariables.VITE_SIM_PRODUCTS_API}/in-life-changes/unsuspension`,
    {
      method: 'POST',
      body: JSON.stringify(props),
      headers: {
        'Content-Type': 'application/json',
      },
    },
  );

  if (!availableActionsResponse.ok) {
    throw new Error('Something went wrong'); //Be improed in next MR
  }
};

export const terminateCards = async (props: { iccids: string[] }) => {
  const availableActionsResponse = await authFetch(
    `${envVariables.VITE_SIM_PRODUCTS_API}/in-life-changes/termination`,
    {
      method: 'POST',
      body: JSON.stringify(props),
      headers: {
        'Content-Type': 'application/json',
      },
    },
  );

  if (!availableActionsResponse.ok) {
    throw new Error('Something went wrong'); //Be improed in next MR
  }
};

export const cancelLocationsOfCards = async (props: { iccids: string[] }) => {
  const availableActionsResponse = await authFetch(
    `${envVariables.VITE_SIM_PRODUCTS_API}/in-life-changes/cancel-location`,
    {
      method: 'POST',
      body: JSON.stringify(props),
      headers: {
        'Content-Type': 'application/json',
      },
    },
  );

  if (!availableActionsResponse.ok) {
    throw new Error('Something went wrong'); //Be improed in next MR
  }
};

type GetAvailableActionsForSimProps = {
  iccids: string[];
};

type ActionAvailability = {
  iccid: string;
  availableManagementActions: SimProductAction[];
};

type AvailableActionsDTO = {
  sims: ActionAvailability[];
};

export const getAvailableActionsForSims = async ({ iccids }: GetAvailableActionsForSimProps) => {
  const availableActionsResponse = await authFetch(
    `${envVariables.VITE_SIM_PRODUCTS_API}/sim-available-actions`,
    {
      method: 'POST',
      body: JSON.stringify({ iccids }),
      headers: {
        'Content-Type': 'application/json',
      },
    },
  );

  const availableActionsDTO: AvailableActionsDTO = await availableActionsResponse.json();
  return availableActionsDTO.sims.reduce((acc, availableSimActions) => {
    return {
      ...acc,
      [availableSimActions.iccid]: availableSimActions.availableManagementActions,
    };
  }, {} as Record<string, SimProductAction[]>);
};
